import { TranslateModule } from '@ngx-translate/core';
import { Component } from '@angular/core';

@Component({
  selector: 'wo-monthly-recurrence',
  templateUrl: './monthly-recurrence.component.html',
  standalone: true,
  imports: [ TranslateModule ],
})
export class MonthlyRecurrenceComponent {}
